import { render, staticRenderFns } from "./PlacesParts.vue?vue&type=template&id=af5fecc2&"
import script from "./PlacesParts.vue?vue&type=script&lang=js&"
export * from "./PlacesParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports